import React from 'react'
import PropTypes from 'prop-types'
import { useCMSEntries, useContentRank } from 'mage-cms'
import { Message } from 'mage-i18n'
import { useHelpContext } from './hooks'

import { TitleSecondary, LinkPrimary, SpacerVertical } from 'mage-deps/@klarna/bubble-ui'
import { pipe, map, flatten, uniq, filter, prop, reject } from 'ramda'
import { EducationAnalytics } from 'education-tools'
import useFilterArticlesByExperiment from './hooks/useFilterArticlesByExperiment'

RelatedContent.propTypes = {
  topicSlugs: PropTypes.arrayOf(PropTypes.string),
  articleId: PropTypes.string,
  analyticsCategory: PropTypes.string.isRequired
}

function getFilters(topicSlugs, articleId) {
  if (articleId) {
    return { links_to_entry: articleId }
  }
  if (topicSlugs && topicSlugs.length > 0) {
    return { 'slug[in]': topicSlugs.join(',') }
  }
}

const getNavigationHandler = (navigation, articleSlug, track) => event => {
  event.preventDefault()
  track()
  navigation.push('article', { articleSlug })
}

function RelatedContent({ topicSlugs, articleId, analyticsCategory }) {
  const { navigation } = useHelpContext()
  const topics = useCMSEntries({
    contentType: 'UHQMTopic',
    filters: getFilters(topicSlugs, articleId)
  })

  const articles = pipe(
    map(topic => topic.articles || []),
    flatten,
    uniq,
    reject(prop('hidden')),
    filter(article => !articleId || article.id !== articleId)
  )(topics || [])

  const filteredArticles = useFilterArticlesByExperiment(articles)

  const sortedArticles = useContentRank(filteredArticles, 3)

  if (!sortedArticles || !sortedArticles.length) return null

  const slicedArticles = sortedArticles.slice(0, 4)

  return (
    <div>
      <TitleSecondary>
        <Message path="hqm.relatedContent.title" fallback="Related content" />
      </TitleSecondary>

      {slicedArticles.map((article, index) => (
        <React.Fragment key={article.id}>
          <EducationAnalytics
            category={analyticsCategory}
            action="print"
            label={article.title}
            referenceType="article"
            referenceId={article.id}
            payload={{ position: index + 1 }}
            googleAnalytics={false}
          />

          <div key={article.id}>
            <SpacerVertical extraSmall />

            <EducationAnalytics
              category={analyticsCategory}
              action="click"
              label={article.title}
              referenceType="article"
              referenceId={article.id}
              payload={{ position: index + 1 }}
            >
              {track => (
                <LinkPrimary onClick={getNavigationHandler(navigation, article.slug, track)}>
                  {article.title}
                </LinkPrimary>
              )}
            </EducationAnalytics>
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}

export default RelatedContent
